import { useMemo, useCallback } from 'react'
import { createTableColumns } from './table-config'

export const useTaskDetailTable = (
  taskInfo: any,
  attackType: any,
  handlers: any,
  setActive: any,
  riskLevelSelectOpen: boolean,
  setRiskLevelSelectOpen: any,
  attackTypeSelectOpen: boolean,
  setAttackTypeSelectOpen: any,
  resourceLevelSelectOpen: boolean,
  setResourceLevelSelectOpen: any,
  interceptStatusSelectOpen: boolean,
  setInterceptStatusSelectOpen: any,
  deviceStatusSelectOpen: boolean,
  setDeviceStatusSelectOpen: any,
  selectedRowKeys: any[],
  setSelectedRowKeys: any,
  useCaseList: any[],
  filterParams: any,
) => {
  // 使用提取的表格列配置
  const columns = useMemo(
    () =>
      createTableColumns(
        taskInfo,
        attackType,
        handlers.getDrawerData,
        setActive,
        riskLevelSelectOpen,
        setRiskLevelSelectOpen,
        attackTypeSelectOpen,
        setAttackTypeSelectOpen,
        resourceLevelSelectOpen,
        setResourceLevelSelectOpen,
        interceptStatusSelectOpen,
        setInterceptStatusSelectOpen,
        deviceStatusSelectOpen,
        setDeviceStatusSelectOpen,
        filterParams,
      ),
    [
      taskInfo,
      attackType,
      handlers.getDrawerData,
      setActive,
      riskLevelSelectOpen,
      setRiskLevelSelectOpen,
      attackTypeSelectOpen,
      setAttackTypeSelectOpen,
      resourceLevelSelectOpen,
      setResourceLevelSelectOpen,
      interceptStatusSelectOpen,
      setInterceptStatusSelectOpen,
      deviceStatusSelectOpen,
      setDeviceStatusSelectOpen,
      filterParams,
    ],
  )

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onSelect: (record: any, selected: boolean) => {
        let newSelectedRowKeys = [...selectedRowKeys]
        if (selected) {
          newSelectedRowKeys.push(record.id)
        } else {
          newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== record.id)
        }
        setSelectedRowKeys(newSelectedRowKeys)
      },
      onSelectAll: (selected: boolean) => {
        const newSelectedRowKeys = selected ? useCaseList.map(item => item.id) : []
        setSelectedRowKeys(newSelectedRowKeys)
      },
    }),
    [selectedRowKeys, setSelectedRowKeys, useCaseList],
  )

  // 处理表头筛选条件
  const processTableFilters = useCallback((filters: any, prevFilters: any) => {
    const newFilters = { ...prevFilters }
    Object.keys(filters).forEach(key => {
      if (filters[key] === null) {
        delete newFilters[key]
      } else {
        newFilters[key] = filters[key]
      }
    })
    return newFilters
  }, [])

  // 处理表单筛选值
  const processFormFilterValue = useCallback(
    (field: string, value: any) =>
      field === 'tag_ids'
        ? (value as string[])?.map(item => item.split('$').slice(1).join('$'))
        : value,
    [],
  )

  // 处理排序逻辑
  const processSortOrder = useCallback((sorter: any) => {
    console.log(sorter, 'sorter')
    if (sorter.order === 'descend') return { field: sorter.field, order: 'SORT_ORDER_DESCENDING' }
    if (sorter.order === 'ascend') return { field: sorter.field, order: 'SORT_ORDER_ASCENDING' }
    return { field: sorter.field, order: undefined }
  }, [])

  return {
    columns,
    rowSelection,
    processTableFilters,
    processFormFilterValue,
    processSortOrder,
  }
}
